import { useState } from "react";
import api from "@/lib/api";
import { apiErr } from "@/lib/format";
import { toast } from "sonner";

/** Interruptor ACTIVA / INACTIVA de una autorización fiscal (CAI). Muestra el estado actual y lo guarda. */
export default function CaiSwitch({ cai, onChanged, disabled = false }) {
  const [busy, setBusy] = useState(false);
  const activa = Boolean(cai.activo || cai.programado);
  const bloqueada = !activa && ["agotada", "vencida"].includes(cai.estado);
  const toggle = async () => {
    if (busy || disabled || bloqueada) return;
    const motivo = window.prompt(activa
      ? (cai.programado ? "Motivo para cancelar esta autorización programada:" : "Motivo para INACTIVAR la autorización (no se podrá emitir con ella):")
      : "Motivo para ACTIVAR la autorización (la que esté vigente para este documento y sucursal quedará inactiva):");
    if (motivo === null) return;
    if (activa && !motivo.trim()) { toast.error("Indica el motivo"); return; }
    setBusy(true);
    try {
      await api.post(`/cai-configurations/${cai.id}/${activa ? "deactivate" : "activate"}`, { motivo });
      toast.success(activa ? "Autorización INACTIVA" : "Autorización ACTIVA");
      onChanged?.();
    } catch (e) { toast.error(apiErr(e)); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" role="switch" aria-checked={activa} onClick={toggle} disabled={busy || disabled || bloqueada}
      data-testid={`cai-switch-${cai.id}`}
      title={bloqueada ? `No se puede activar: ${cai.estado}` : activa ? "Clic para INACTIVAR" : "Clic para ACTIVAR"}
      className="inline-flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed">
      <span className={`relative inline-block w-8 h-4 rounded-full transition ${activa ? "bg-agro-green" : "bg-border"}`}>
        <span className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-all ${activa ? "left-[18px]" : "left-0.5"}`} />
      </span>
      <span className={`text-[10px] font-bold tracking-wider ${activa ? "text-agro-green" : "text-text-muted"}`}>
        {busy ? "…" : activa ? "ACTIVA" : "INACTIVA"}
      </span>
    </button>
  );
}
